const content = {
  additionalNeeded: "Additional <1>{volumeNeeded} {volumeType} needed</1>",
  progressLabel: "Min. Target: {targetAmount}",
  exemptLabel: "You Qualified with {volumeType} Exemption",
  lsExemptLabel: "You are exempt from the Monthly GPV requirement.",
  isMQ: "You've manually qualified for this requirement.",
} as const;

export default content;
